import createIcon from '../../createIcon';

/**
 * @component @name Public
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMkM2LjQ4IDIgMiA2LjQ4IDIgMTJDMiAxNy41MiA2LjQ4IDIyIDEyIDIyQzE3LjUyIDIyIDIyIDE3LjUyIDIyIDEyQzIyIDYuNDggMTcuNTIgMiAxMiAyWk0xMSAxOS45M0M3LjA1IDE5LjQ0IDQgMTYuMDggNCAxMkM0IDExLjM4IDQuMDggMTAuNzkgNC4yMSAxMC4yMUw5IDE1VjE2QzkgMTcuMSA5LjkgMTggMTEgMThWMTkuOTNaTTE3LjkgMTcuMzlDMTcuNjQgMTYuNTggMTYuOSAxNiAxNiAxNkgxNVYxM0MxNSAxMi40NSAxNC41NSAxMiAxNCAxMkg4VjEwSDEwQzEwLjU1IDEwIDExIDkuNTUgMTEgOVY3SDEzQzE0LjEgNyAxNSA2LjEgMTUgNVY0LjU5QzE3LjkzIDUuNzggMjAgOC42NSAyMCAxMkMyMCAxNC4wOCAxOS4yIDE1Ljk3IDE3LjkgMTcuMzlaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Public = createIcon('Public', [
  [
    'path',
    {
      d: 'M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM11 19.93C7.05 19.44 4 16.08 4 12C4 11.38 4.08 10.79 4.21 10.21L9 15V16C9 17.1 9.9 18 11 18V19.93ZM17.9 17.39C17.64 16.58 16.9 16 16 16H15V13C15 12.45 14.55 12 14 12H8V10H10C10.55 10 11 9.55 11 9V7H13C14.1 7 15 6.1 15 5V4.59C17.93 5.78 20 8.65 20 12C20 14.08 19.2 15.97 17.9 17.39Z',
      key: '1xqt7w',
    },
  ],
]);

export default Public;
